import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 203 326",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M35 201.484C35 239.892 63.0122 263.284 100.843 263.284C138.097 263.284 166.686 239.892 166.686 200.328C166.686 164.519 141.562 141.416 110.373 141.416C105.175 141.416 99.9768 142.282 97.9553 143.438L97.3777 143.149L125.968 91.4561C128.278 87.4131 129.144 83.6589 129.144 79.9047C129.144 68.9309 120.192 62 110.373 62C103.153 62 96.5114 65.7542 92.4684 73.2627L49.4393 152.968C40.1981 169.717 35 184.734 35 201.484ZM74.8524 201.772C74.8524 185.889 85.2487 174.626 100.843 174.626C116.438 174.626 126.834 185.889 126.834 201.772C126.834 217.944 116.438 229.207 100.843 229.207C85.2487 229.207 74.8524 217.944 74.8524 201.772Z",
      fill: "#E5E5E5"
    }, null, -1)
  ])))
}
export default { render: render }